import { TypeGuard } from '@adreno-common';
import {
  Inputs,
  MatrixInputs,
  ConcreteInputs,
  TextInput,
  NumberInput,
  DateInput,
  ComboInput,
  CheckInput,
  RadioInput,
} from '../code';

export const isMatrixInput: TypeGuard<Inputs, MatrixInputs> = (
  input: Inputs
): input is MatrixInputs => input.type === 'matrix';
export const isConcreteInput: TypeGuard<Inputs, ConcreteInputs> = (
  input: Inputs
): input is ConcreteInputs => input.type !== 'matrix';
export const isTextInput: TypeGuard<ConcreteInputs, TextInput> = (
  input: ConcreteInputs
): input is TextInput => input.type === 'text';
export const isNumberInput: TypeGuard<ConcreteInputs, NumberInput> = (
  input: ConcreteInputs
): input is NumberInput => input.type === 'number';
export const isDateInput: TypeGuard<ConcreteInputs, DateInput> = (
  input: ConcreteInputs
): input is DateInput => input.type === 'date';
export const isComboInput: TypeGuard<ConcreteInputs, ComboInput> = (
  input: ConcreteInputs
): input is ComboInput => input.type === 'combo';
export const isCheckInput: TypeGuard<ConcreteInputs, CheckInput> = (
  input: ConcreteInputs
): input is CheckInput => input.type === 'check';
export const isRadioInput: TypeGuard<ConcreteInputs, RadioInput> = (
  input: ConcreteInputs
): input is RadioInput => input.type === 'radio';
